import { render, staticRenderFns } from "./AccountsAcounting.vue?vue&type=template&id=4e8050bc&"
import script from "./AccountsAcounting.vue?vue&type=script&lang=js&"
export * from "./AccountsAcounting.vue?vue&type=script&lang=js&"
import style0 from "./AccountsAcounting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports